<template>
  <el-dialog
    title="编辑图片"
    :close-on-click-modal="false"
    append-to-body
    :visible.sync="dialogVisible"
    @close="closeDialog"
    class="cos-image-edit dialog-index-max"
    width="1000px"
  >
    <div
      style="text-align: center; height: 63vh; overflow: auto"
      v-loading="iframeLoading"
    >
      <iframe
        id="iframe"
        ref="iframe"
        :src="iframeSrc"
        width="100%"
        height="98.5%"
        frameborder="0"
        scrolling="auto"
        @load="iframeLoad"
      ></iframe>
    </div>
    <span slot="footer" class="flex" style="justify-content: space-between">
      <div class="flex" style="align-items: center">
        <!-- <el-checkbox
          v-model="checked"
          style="margin: 0px; margin-right: 10px"
          v-if="power['添加'] && showCheck"
          @change="change"
          >转存媒资库</el-checkbox
        >
        <span v-if="!showCheck && showInput" style="margin-right: 10px"
          >文件标题</span
        > -->
        <el-checkbox
          v-model="checked"
          style="margin: 0px; margin-right: 10px"
          v-if="!showNewImg"
          @change="change"
          :disabled="iframeLoading"
          >转存媒资库</el-checkbox
        >
        <el-radio-group
          v-if="showNewImg"
          class="changeOri"
          style="height: 32px"
          v-model="editImgOrNewImg"
          :disabled="iframeLoading"
        >
          <el-radio class="m-r-10" :label="false">新建副本</el-radio>
          <el-radio :label="true">修改原图</el-radio>
        </el-radio-group>
        <el-input
          v-model="title"
          class="m-r-10"
          :style="{
            width: '300px',
          }"
          size="small"
          placeholder="文件标题"
          v-if="!editImgOrNewImg || source == 'mediaLibrary'"
          :disabled="iframeLoading"
        ></el-input>
      </div>
      <div>
        <el-button
          size="small"
          style="margin-left: 10px"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="small"
          type="primary"
          style="margin-left: 10px"
          @click="saveImg"
          :disabled="iframeLoading"
          >{{ confirmButton }}</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>
<script>
import { getAuth } from "@/server/api/cos_js/sign.js";
import { saveFile } from "@/server/api/cos.js";
import { update as mediaLibraryUpdate } from "@/server/api/mediaLibrary.js";
export default {
  watch: {},
  data() {
    return {
      dialogVisible: false,
      iframeSrc: "",
      imgUrl: "",
      url: "",
      isChanged: false,
      baseUrl: env.img_edit, //iframe基础地址
      origin: env.img_edit.substring(0, env.img_edit.indexOf("/dist")),
      fileName: "",
      checked: false, //是否加入媒资库
      title: "",
      power: "",
      fileInfo: "",
      inputTitle: "转存媒资库",
      showCheck: true,
      isEdit: false,
      source: "",
      path: "",
      confirmButton: "保存",
      height: undefined,
      showInput: true,
      isVodUrl: false,
      editImgOrNewImg: false,
      showNewImg: false,
      clickSave: false,
      count: 0, //判断图片地址有没有改变
      initialUrl: "", //图片编辑器第一次返回的地址
      iframeLoading: false,
    };
  },
  created() {},
  mounted() {
    this.power = this.utils.currentPower("媒体资源库管理");
    this.height = (window.innerHeight * 62.055) / 100;
  },
  methods: {
    change(data) {
      if (data) {
        this.title = this.fileName;
      } else {
        this.title = "";
      }
    },
    showModal(resp, file_info, edit) {
      this.iframeLoading = true;
      this.source = "";
      this.path = "";
      this.count = 0;
      this.title = "";
      this.checked = false;
      this.editImgOrNewImg = false;
      this.clickSave = false;
      if (file_info) {
        this.fileInfo = file_info;
        console.log("文件信息", this.fileInfo);
        this.fileName =
          file_info.name.indexOf(".") != -1
            ? file_info.name.substring(0, file_info.name.lastIndexOf("."))
            : file_info.name;
        console.log("文件名", this.fileName);
      } else {
        this.fileInfo = null;
      }
      if (edit) {
        this.showNewImg = true;
        if (edit.source == "mediaLibrary") {
          this.title = this.fileName;
          this.isEdit = true;
          this.source = "mediaLibrary";
          this.checked = true;
          this.path = edit.path;
          this.showCheck = false;
        } else if (edit.source == "imageEdit") {
          // 从媒资库选择的图片就不显示转存媒资库
          if (
            resp.response.url.indexOf("saas/image") == -1 ||
            resp.response.url.indexOf("saas/image/media") != -1
          ) {
            this.showCheck = false;
            this.showInput = false;
            this.isVodUrl = true;
          } else {
            this.showCheck = true;
            this.showInput = true;
            this.isVodUrl = false;
          }
        }
      } else {
        this.showNewImg = false;
      }
      window.addEventListener("message", this.getUrl);
      this.imgUrl = "";
      // console.log("处理数据", resp);
      this.url = resp.response.url;
      let sign = "";
      if (resp.response.opt) {
        sign = getAuth(resp.response.opt);
      } else {
        // console.log("执行另一种");
        // let obj_test = {
        //   SecretId: resp.response.tmpSecretId,
        //   SecretKey: resp.response.tmpSecretKey,
        //   pathName: resp.response.url.split("?")[0].split(".com/")[1],
        //   method: "get",
        // };
        // console.log("参数", obj_test);
        // sign = getAuth(obj_test);
      }
      //   console.log("获取的签名", sign);
      let waterStr = resp.response.waterPath.split("?sign=")[0];
      let imgItem = {
        bucket: resp.response.opt.Bucket,
        region: resp.response.opt.Region,
        path: resp.response.opt.pathName.substr(1),
        sign: sign,
        token: resp.response.opt.token,
        waterPath: waterStr.split(".com/")[1],
        waterToken: resp.response.token,
        waterSign: "sign=" + resp.response.waterSign,
        dialogWidth: 1000 + "px",
        dialogHeight: this.height + "px",
      };
      console.log("imgItem", imgItem);
      this.iframeSrc = this.baseUrl;
      imgItem = JSON.stringify(imgItem);
      this.iframeSrc = this.iframeSrc + `?imgItem=${imgItem}`;
      console.log("地址", this.iframeSrc);
      this.dialogVisible = true;
    },
    //编辑后的图片转存
    async saveImg() {
      this.isChanged = true;
      if (this.checked) {
        if (!this.title) {
          this.warning("文件标题不能为空");
          return;
        }
      }

      // console.log("图片地址", this.imgUrl);
      // let file;
      // let result = false;
      // await downloadFile(this.imgUrl).then((res) => {
      //   if (res.name) {
      //     result = true;
      //     file = res;
      //   }
      // });
      // console.log("从接口得到的文件", file);
      this.$refs.iframe.contentWindow.postMessage("finishClip", "*");
      this.clickSave = true;
      setTimeout(() => {
        this.saveUrl();
      }, 50);
    },
    closeDialog() {
      window.removeEventListener("message", this.getUrl);
      if (!this.isChanged) {
        // console.log("发送原图");
        this.$emit("change", this.url);
      }
    },
    getUrl(data) {
      // console.log("监听到了");
      console.log("接受到的信息", data);
      if (data.origin == this.origin) {
        if (this.count == 0) {
          this.initialUrl = data.data;
          this.count = 1;
        }
        this.imgUrl = data.data;
        // if (this.clickSave) {
        //   this.saveUrl()
        // }
      }
    },
    saveUrl() {
      if (this.imgUrl == this.initialUrl) {
        console.log("没有改图片");
      }
      //如果没有修改图片则不调用图片修改接口
      if (!this.showNewImg) {
        console.log("是新上传的图片");
        //新上传的图片
        if (this.checked) {
          //勾选转存媒资库
          if (!this.title) {
            this.warning("请填写文件标题");
            return;
          }
        } else if (this.imgUrl == this.initialUrl) {
          //未勾选转存媒资库
          this.$emit("change", this.url);
          this.dialogVisible = false;
          return;
        }
      } else {
        //编辑的时候
        if (this.source == "mediaLibrary") {
          //媒资库编辑
          if (this.imgUrl == this.initialUrl && this.title == this.fileName) {
            //未修改图片和标题直接关闭弹窗
            this.dialogVisible = false;
            return;
          } else if (
            this.imgUrl == this.initialUrl &&
            this.title != this.fileName
          ) {
            console.log("只修改了标题");
            //只修改了标题
            mediaLibraryUpdate({
              id: this.fileInfo.id,
              title: this.title,
            }).then((res) => {
              if (res.code === 0) {
                console.log("标题修改结果");
                this.success("修改成功");
                this.dialogVisible = false;
                this.$emit("pageCallback", { getList: true });
              } else {
                this.warning(res.msg);
              }
            });
            return;
          }
        } else {
          //非媒资库编辑
          if (this.editImgOrNewImg) {
            //选择修改原图
            if (this.imgUrl == this.initialUrl) {
              //未修改图片，直接关闭弹窗
              this.$emit("change", this.url);
              this.dialogVisible = false;
              return;
            }
          } else {
            //选择新建副本
            if (this.imgUrl == this.initialUrl && !this.title) {
              //未修改图片也没填写标题直接返回
              this.$emit("change", this.url);
              this.dialogVisible = false;
              return;
            }
          }
        }
      }
      console.log("开始保存");
      let params = {
        url: this.imgUrl,
        changeOri: this.editImgOrNewImg,
      };
      // if (this.fileInfo.id) {
      //   params.changeOri = true;
      // }
      if (this.url) {
        let end = this.url.indexOf("%3F");
        if (end == -1) {
          end = this.url.indexOf("?");
        }
        params.originUrl = this.url.substring(0, end);
      }
      if (this.title) {
        params.title = this.title;
      }

      if (this.checked) {
        let time_now = new Date();
        let month = time_now.getMonth() + 1;
        params.title = this.title;
        if (this.source == "mediaLibrary") {
          params.onlyVod = true;
          params.id = this.fileInfo.id;
        } else {
          params.path =
            "/image/" +
            time_now.getFullYear() +
            "-" +
            (month < 10 ? "0" + month : month);
        }
        params.type = "image";
        params.size = this.fileInfo.size;
      }
      console.log("转存参数", params);
      saveFile(params).then(
        (res) => {
          console.log(res);
          if (res.code === 0) {
            //flase 新建副本 true 修改原图
            this.$emit("change", res.data);
            this.dialogVisible = false;
            if (this.isEdit) {
              this.$emit("pageCallback", { getList: true });
              this.success("后台转存中，请稍候刷新查看");
            } else if (this.checked) {
              this.success("转存媒资库成功");
            }
          } else {
            this.isChanged = false;
            this.warning(res.msg);
          }
        },
        (err) => {
          this.isChanged = false;
        }
      );
    },
    //加载完成前禁用操作
    iframeLoad() {
      this.iframeLoading = false;
    },
  },
};
</script>
<style lang="scss">
.changeOri {
  display: flex;
  align-items: center;
  .el-radio {
    margin: 0;
    margin-right: 10px;
  }
}
</style>
<style lang="scss" scoped>
.cos-image-edit ::v-deep .el-dialog__body {
  padding: 10px 0px 10px 0px !important;
}
</style>
